import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import { attr } from '@ember-data/model';
export default EmberDataBaseFragment.extend({
  marginBasisPoints: attr('number'),
  marginCents: attr('money-proto'),
  equals(other) {
    if (other === null) {
      return false;
    }
    return this.marginBasisPoints === other.get('marginBasisPoints');
  }
}).reopenClass({
  _modelNameForMigration: 'cost-plus-processing-fee'
});